import { v4 as uuid } from 'uuid';
import { Grid, Link, Typography } from '@mui/material';
import LinkData from '../../../../models/LinkData';
import Utils from '../../../../utils/Utils';
import CloseButton from '../../../Buttons/Close';

interface HeaderMenuProps {
  menus: LinkData[];
  isEditing: boolean;
  direction?: 'row' | 'column';
  handleMenuDelete: () => void;
  handleOpen: () => void;
}

const HeaderMenu = ({
  menus, isEditing, direction = 'row', handleMenuDelete, handleOpen,
}: HeaderMenuProps) => (
  <Grid item xs={12} sx={{ ...Utils.hoverBorder(isEditing), padding: '16px' }}>
    {isEditing && <CloseButton updateHandler={handleMenuDelete} />}
    <Grid container spacing={2} direction={direction} alignItems="center" justifyContent="center" wrap="wrap" onClick={handleOpen}>
      {menus.map((menu) => (
        <Grid key={uuid()} item xs="auto">
          {!isEditing && (
            <Link href={menu.linkData.url} target={menu.linkData.openType} rel="noreferrer" underline="hover" color="black" variant="h6" m="auto">
              {menu.title}
            </Link>
          )}
          {isEditing && (
            <Typography color="black" variant="h6" m="auto">
              {menu.title}
            </Typography>
          )}
        </Grid>
      ))}
    </Grid>
  </Grid>
);

export default HeaderMenu;
